import React from 'react'

const Testimonials = () => {
  return (
    <>
    <div className="section-header">
            <h2>What our customers say</h2>
          </div>
          <div className="testimonial-container">
            <div className="testimonial-card">
              <div className="testimonial-logo">
                {/* <img
                  src="https://conglobase.com/assets/media/Varients/SVG/conglobase_original.svg"
                  alt=""
                /> */}
                <h3>Katariya Movers</h3>
              </div>
              <div className="testimonial-content">
                <div className="testimonial-text">
                  <p>
                    <i>
                      "Shoora's solution is a game-changer. Fleet safety and
                      efficiency soared since we partnered with them. Its a
                      greatfull impact around the world."
                    </i>
                  </p>
                </div>
                <div className="testimonial-author">
                  <h6>Shashank Jain</h6>
                  <p>Kataria Movers</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-logo">
                <img
                  src="/images/clients/kapoor.png"
                  alt=""
                />
              </div>
              <div className="testimonial-content">
                <div className="testimonial-text">
                  <p>
                    <i>
                      "Shoora’s platform revolutionized our fleet management.
                      Risk detection is unmatched. We’ve significantly reduced
                      downtime and costs. Highly recommend!"
                    </i>
                  </p>
                </div>
                <div className="testimonial-author">
                  <h6>Vikrant Kapoor</h6>
                  <p>Kapoor Diesels</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-logo">
                <img
                  src="/images/clients/blr-logistics.png"
                  alt="shoora client blr logistics"
                />
              </div>
              <div className="testimonial-content">
                <div className="testimonial-text">
                  <p>
                    <i>
                      “Our customers need assurance—there is a definite value
                      pool shift to solutions and services—partnering with
                      Shoora is our value-creation initiative to re-assure our
                      customers of safety ”
                    </i>
                  </p>
                </div>
                <div className="testimonial-author">
                  <h6>Abhishek Goel</h6>
                  <p>BLR Logistics</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-logo">
                <img
                  src="/images/clients/instant.png"
                  alt="shoora client instant transport"
                />
              </div>
              <div className="testimonial-content">
                <div className="testimonial-text">
                  <p>
                    <i>
                      “We’ve gone from having to give a two hour, stagnant
                      delivery window—that our drivers would sometimes miss—to
                      minute-by-minute updates for our customers.”
                    </i>
                  </p>
                </div>
                <div className="testimonial-author">
                  <h6>Jasveer Singh</h6>
                  <p>Instant Transport</p>
                </div>
              </div>
            </div>
          </div>
    </>
  )
}

export default Testimonials